import {KeycloakInstance} from "keycloak-js";
import { fetchHydra, hydraDataProvider } from "@api-platform/admin";
import { parseHydraDocumentation } from "@api-platform/api-doc-parser";



export default (keycloak: KeycloakInstance, url) => {
    const getHeaders = () => {
        return {
            Authorization: `Bearer ${keycloak.token}`
        }
    };

    const jwtEnabledFetchHydra = (url, options = {}) =>
        fetchHydra(url, {
            ...options,
            headers: getHeaders,
        });

    const jwtEnabledParseHydraDocumentation = (url, options = {}) =>
        parseHydraDocumentation(url, {
            ...options,
            headers: getHeaders,
        });


    return hydraDataProvider({
        entrypoint: url,
        httpClient: jwtEnabledFetchHydra,
        apiDocumentationParser: jwtEnabledParseHydraDocumentation,
        useEmbedded: true // useEmbedded parameter
    });
}
